export const RESET_PASSWORD_DEFAULT_EXPIRES_IN_MINUTES = 10
export const RESET_PASSWORD_CODE_LENGTH = 6

export const RESET_PASSWORD_STEP_COPY = {
  email: {
    title: 'Restablecer contraseña',
    subtitle: 'Ingresa tu correo para enviarte un código de verificación'
  },
  password: {
    title: 'Ingresa tu nueva contraseña',
    subtitle: 'Debe cumplir las reglas de seguridad.'
  }
}

export const RESET_PASSWORD_ERROR_MESSAGES = {
  invalid_reset_code: 'Código inválido. Verifica el correo más reciente o pide el reenvío del mismo.',
  reset_code_expired: 'El código expiró. Solicita uno nuevo.',
  reset_code_locked: 'Demasiados intentos. Espera unos minutos e inténtalo de nuevo.',
  invalid_reset_token: 'El código ya no es válido. Solicita uno nuevo.',
  default: 'No fue posible completar la solicitud. Intenta nuevamente.'
}

export const RESET_PASSWORD_VALIDATION_ERROR_MESSAGE =
  'La contraseña no cumple con las reglas requeridas.'

export const RESET_PASSWORD_RESEND_SUCCESS_MESSAGE = (expiresInMinutes) =>
  `Si existe una cuenta asociada, te enviamos un código válido por ${expiresInMinutes} minutos.`

export const RESET_PASSWORD_CODE_STEP_COPY = (expiresInMinutes) => ({
  title: 'Código de verificación',
  subtitle: `Ingresa el código enviado a tu correo. Vence en ${expiresInMinutes} minutos.`
})
